// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5ed2963d","453":"5b68ccb0"}[chunkId] + ".chunk.js";
};